import { useQuery } from '@tanstack/react-query';

import { getCredits } from '../api';
import { creditsQueryKeys } from '../data';
import { useCreditsFilter, useCreditsPagination } from '../store';

export const useGetCredits = () => {
  const filters = useCreditsFilter();
  const pagination = useCreditsPagination();

  const filesQuery = useQuery({
    queryKey: [
      ...creditsQueryKeys.getCredits,
      {
        ...filters,
        ...pagination,
      },
    ],
    queryFn: getCredits.bind(null, { ...filters, ...pagination }),
    staleTime: 5_000,
  });

  return filesQuery;
};
